import { loyaltyActivatedCouponStorageKey } from 'pi-kiosk-shared/loyalty/loyaltySessionHandoff';
import {
  clearPromoActivatedRewardHandoff,
} from 'pi-kiosk-shared/promo/promoSessionHandoff';
import { readActivatedPromoRewardHandoff } from '../promotions/readActivatedPromoRewardHandoff.js';

export interface CheckoutPaymentIncentives {
  readonly activatedCouponId: string | null;
  readonly activatedPromoRewardId: string | null;
}

/**
 * Payment-create incentive ids. §3.8 — server session metadata wins over handoff.
 * When `serverPromoResolved` is true, `serverActivatedPromoRewardId` (including null after
 * RELEASE) is authoritative and stale sessionStorage handoff is cleared/ignored.
 */
export function resolveCheckoutPaymentIncentives(input: {
  readonly tenantCode: string;
  readonly checkoutSessionId: string | null;
  readonly serverActivatedPromoRewardId?: string | null;
  /** True when checkout session was loaded and promotions SoT was observed. */
  readonly serverPromoResolved?: boolean;
}): CheckoutPaymentIncentives {
  let activatedPromoRewardId: string | null;
  if (input.serverPromoResolved === true) {
    const serverId = input.serverActivatedPromoRewardId?.trim() ?? '';
    activatedPromoRewardId = serverId.length > 0 ? serverId : null;
    if (
      activatedPromoRewardId == null &&
      input.checkoutSessionId != null &&
      input.checkoutSessionId.length > 0
    ) {
      clearPromoActivatedRewardHandoff(input.tenantCode, input.checkoutSessionId);
    }
  } else {
    activatedPromoRewardId = readActivatedPromoRewardHandoff(
      input.tenantCode,
      input.checkoutSessionId,
    );
  }

  let activatedCouponId: string | null = null;
  if (
    input.checkoutSessionId != null &&
    input.checkoutSessionId.length > 0 &&
    typeof sessionStorage !== 'undefined'
  ) {
    try {
      activatedCouponId =
        sessionStorage.getItem(
          loyaltyActivatedCouponStorageKey(input.tenantCode, input.checkoutSessionId),
        ) ?? null;
      if (activatedCouponId != null && activatedCouponId.length === 0) {
        activatedCouponId = null;
      }
    } catch {
      activatedCouponId = null;
    }
  }
  return { activatedCouponId, activatedPromoRewardId };
}
